import React from 'react';
import { Link } from 'react-router-dom';
import { Zap, TrendingUp, Gift, Calculator } from 'lucide-react';

function Tools() {
  return (
    <div style={{ 
      backgroundColor: '#0a0e1a',
      minHeight: '100vh',
      padding: '60px'
    }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {/* Header */}
        <div style={{ marginBottom: '60px', textAlign: 'center' }}>
          <h1 style={{ 
            fontSize: '48px',
            fontWeight: '800',
            margin: '0 0 20px 0',
            color: '#ffffff',
            letterSpacing: '-0.5px'
          }}>
            Professional Betting Tools
          </h1>
          <p style={{ 
            fontSize: '18px',
            color: '#64748b',
            maxWidth: '700px',
            margin: '0 auto',
            lineHeight: '1.7'
          }}>
            Real-time analytics and calculators to maximize your sports betting edge
          </p>
        </div>

        {/* Analytics Tools Section */}
        <div style={{ marginBottom: '60px' }}>
          <h2 style={{ 
            fontSize: '28px',
            fontWeight: '700',
            margin: '0 0 30px 0',
            color: '#ffffff'
          }}>
            Analytics Tools
          </h2>
          <div style={{ 
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: '25px'
          }}>
        {/* Arbitrage */}
        <Link to="/arbitrage" style={{ textDecoration: 'none' }}>
        <div style={{
            padding: '25px',
            backgroundColor: '#1a1f2e',
            border: '1px solid #2d3748',
            borderRadius: '12px',
            transition: 'all 0.3s',
            cursor: 'pointer',
            height: '140px',
            display: 'flex',
            flexDirection: 'column'
        }}
        onMouseOver={(e) => {
            e.currentTarget.style.borderColor = '#00d9ff';
            e.currentTarget.style.transform = 'translateY(-5px)';
            e.currentTarget.style.boxShadow = '0 12px 40px rgba(0, 217, 255, 0.2)';
        }}
        onMouseOut={(e) => {
            e.currentTarget.style.borderColor = '#2d3748';
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = 'none';
        }}
        >
            {/* Icon + Title Row */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '15px' }}>
            <div style={{
                width: '50px',
                height: '50px',
                borderRadius: '10px',
                background: 'linear-gradient(135deg, rgba(0, 217, 255, 0.2) 0%, rgba(16, 185, 129, 0.2) 100%)',
                border: '1px solid rgba(0, 217, 255, 0.3)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
            }}>
                <Zap size={24} color="#00d9ff" />
            </div>
            <h3 style={{ 
                fontSize: '20px',
                fontWeight: '700',
                margin: 0,
                color: '#ffffff'
            }}>
                Arbitrage
            </h3>
            </div>
            <p style={{ 
            fontSize: '14px',
            lineHeight: '1.6',
            color: '#64748b',
            margin: 0
            }}>
            Lock in profit by betting across multiple sportsbooks. Real-time updates 
            ensure you never miss an advantage bet.
            </p>
        </div>
        </Link>

        {/* Positive EV */}
        <Link to="/positive-ev" style={{ textDecoration: 'none' }}>
        <div style={{
            padding: '25px',
            backgroundColor: '#1a1f2e',
            border: '1px solid #2d3748',
            borderRadius: '12px',
            transition: 'all 0.3s',
            cursor: 'pointer',
            height: '140px',
            display: 'flex',
            flexDirection: 'column'
        }}
        onMouseOver={(e) => {
            e.currentTarget.style.borderColor = '#10b981';
            e.currentTarget.style.transform = 'translateY(-5px)';
            e.currentTarget.style.boxShadow = '0 12px 40px rgba(16, 185, 129, 0.2)';
        }}
        onMouseOut={(e) => {
            e.currentTarget.style.borderColor = '#2d3748';
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = 'none';
        }}
        >
            <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '15px' }}>
            <div style={{
                width: '50px',
                height: '50px',
                borderRadius: '10px',
                background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.2) 0%, rgba(0, 217, 255, 0.2) 100%)',
                border: '1px solid rgba(16, 185, 129, 0.3)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
            }}>
                <TrendingUp size={24} color="#10b981" />
            </div>
            <h3 style={{ 
                fontSize: '20px',
                fontWeight: '700',
                margin: 0,
                color: '#ffffff'
            }}>
                Positive EV
            </h3>
            </div>
            <p style={{ 
            fontSize: '14px',
            lineHeight: '1.6',
            color: '#64748b',
            margin: 0
            }}>
            Identify bets with long-term positive expected value. Built-in Kelly Criterion 
            calculator for optimal bankroll management.
            </p>
        </div>
        </Link>

        {/* Bonus Conversion */}
        <Link to="/promo-conversion" style={{ textDecoration: 'none' }}>
        <div style={{
            padding: '25px',
            backgroundColor: '#1a1f2e',
            border: '1px solid #2d3748',
            borderRadius: '12px',
            transition: 'all 0.3s',
            cursor: 'pointer',
            height: '140px',
            display: 'flex',
            flexDirection: 'column'
        }}
        onMouseOver={(e) => {
            e.currentTarget.style.borderColor = '#f59e0b';
            e.currentTarget.style.transform = 'translateY(-5px)';
            e.currentTarget.style.boxShadow = '0 12px 40px rgba(245, 158, 11, 0.2)';
        }}
        onMouseOut={(e) => {
            e.currentTarget.style.borderColor = '#2d3748';
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = 'none';
        }}
        >
            <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '15px' }}>
            <div style={{
                width: '50px',
                height: '50px',
                borderRadius: '10px',
                background: 'linear-gradient(135deg, rgba(245, 158, 11, 0.2) 0%, rgba(239, 68, 68, 0.2) 100%)',
                border: '1px solid rgba(245, 158, 11, 0.3)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
            }}>
                <Gift size={24} color="#f59e0b" />
            </div>
            <h3 style={{ 
                fontSize: '20px',
                fontWeight: '700',
                margin: 0,
                color: '#ffffff'
            }}>
                Bonus Conversion
            </h3>
            </div>
            <p style={{ 
            fontSize: '14px',
            lineHeight: '1.6',
            color: '#64748b',
            margin: 0
            }}>
            Maximize the value of promotional offers like bonus bets. Convert free bets 
            into real cash with optimal hedging strategies.
            </p>
        </div>
        </Link>
          </div>
        </div>

        {/* Betting Calculators Section */}
        <div style={{ marginTop: '60px' }}>
          <h2 style={{ 
            fontSize: '28px',
            fontWeight: '700',
            margin: '0 0 30px 0',
            color: '#ffffff'
          }}>
            Betting Calculators
          </h2>
          <div style={{ 
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: '25px'
          }}>
        {/* Arbitrage Calculator */}
        <Link to="/arbitrage-calculator" style={{ textDecoration: 'none' }}>
        <div style={{
            padding: '25px',
            backgroundColor: '#1a1f2e',
            border: '1px solid #2d3748',
            borderRadius: '12px',
            transition: 'all 0.3s',
            cursor: 'pointer',
            height: '140px',
            display: 'flex',
            flexDirection: 'column'
        }}
        onMouseOver={(e) => {
            e.currentTarget.style.borderColor = '#00d9ff';
            e.currentTarget.style.transform = 'translateY(-3px)';
        }}
        onMouseOut={(e) => {
            e.currentTarget.style.borderColor = '#2d3748';
            e.currentTarget.style.transform = 'translateY(0)';
        }}
        >
            <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '15px' }}>
            <div style={{
                width: '50px',
                height: '50px',
                borderRadius: '10px',
                background: 'linear-gradient(135deg, rgba(0, 217, 255, 0.2) 0%, rgba(16, 185, 129, 0.2) 100%)',
                border: '1px solid rgba(0, 217, 255, 0.3)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
            }}>
                <Calculator size={24} color="#00d9ff" />
            </div>
            <h3 style={{ 
                fontSize: '20px',
                fontWeight: '700',
                margin: 0,
                color: '#ffffff'
            }}>
                Arbitrage
            </h3>
            </div>
            <p style={{ 
            fontSize: '14px',
            lineHeight: '1.6',
            color: '#64748b',
            margin: 0
            }}>
            Manually adjust arbitrage opportunities to explore different scenarios and evaluate outcomes.
            </p>
        </div>
        </Link>

        {/* Positive EV Calculator */}
        <Link to="/positive-ev-calculator" style={{ textDecoration: 'none' }}>
        <div style={{
            padding: '25px',
            backgroundColor: '#1a1f2e',
            border: '1px solid #2d3748',
            borderRadius: '12px',
            transition: 'all 0.3s',
            cursor: 'pointer',
            height: '140px',
            display: 'flex',
            flexDirection: 'column'
        }}
        onMouseOver={(e) => {
            e.currentTarget.style.borderColor = '#10b981';
            e.currentTarget.style.transform = 'translateY(-3px)';
        }}
        onMouseOut={(e) => {
            e.currentTarget.style.borderColor = '#2d3748';
            e.currentTarget.style.transform = 'translateY(0)';
        }}
        >
            <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '15px' }}>
            <div style={{
                width: '50px',
                height: '50px',
                borderRadius: '10px',
                background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.2) 0%, rgba(0, 217, 255, 0.2) 100%)',
                border: '1px solid rgba(16, 185, 129, 0.3)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
            }}>
                <Calculator size={24} color="#10b981" />
            </div>
            <h3 style={{ 
                fontSize: '20px',
                fontWeight: '700',
                margin: 0,
                color: '#ffffff'
            }}>
                Positive EV
            </h3>
            </div>
            <p style={{ 
            fontSize: '14px',
            lineHeight: '1.6',
            color: '#64748b',
            margin: 0
            }}>
            Manually adjust +EV opportunities to explore different scenarios and evaluate outcomes.
            </p>
        </div>
        </Link>

        {/* Promo Calculator */}
        <Link to="/promo-conversion-calculator" style={{ textDecoration: 'none' }}>
        <div style={{
            padding: '25px',
            backgroundColor: '#1a1f2e',
            border: '1px solid #2d3748',
            borderRadius: '12px',
            transition: 'all 0.3s',
            cursor: 'pointer',
            height: '140px',
            display: 'flex',
            flexDirection: 'column'
        }}
        onMouseOver={(e) => {
            e.currentTarget.style.borderColor = '#f59e0b';
            e.currentTarget.style.transform = 'translateY(-3px)';
        }}
        onMouseOut={(e) => {
            e.currentTarget.style.borderColor = '#2d3748';
            e.currentTarget.style.transform = 'translateY(0)';
        }}
        >
            <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '15px' }}>
            <div style={{
                width: '50px',
                height: '50px',
                borderRadius: '10px',
                background: 'linear-gradient(135deg, rgba(245, 158, 11, 0.2) 0%, rgba(239, 68, 68, 0.2) 100%)',
                border: '1px solid rgba(245, 158, 11, 0.3)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
            }}>
                <Calculator size={24} color="#f59e0b" />
            </div>
            <h3 style={{ 
                fontSize: '20px',
                fontWeight: '700',
                margin: 0,
                color: '#ffffff'
            }}>
                Bonus Conversion
            </h3>
            </div>
            <p style={{ 
            fontSize: '14px',
            lineHeight: '1.6',
            color: '#64748b',
            margin: 0
            }}>
            Manually adjust bonus bet conversion opportunities to explore different scenarios and evaluate outcomes.
            </p>
        </div>
        </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Tools;